<template>
  <!-- 【P120】PC 版登录（桌面宽度下使用）
       背景：market / client 各端原先未登录时**无条件**渲染 ClientLogin（手机版登录 UI），
             于是在 PC 浏览器打开始终是 H5 那种窄条样式（用户反馈「打开的是 H5 的」）。
             本组件与 login.vue 的桌面分屏同一套视觉（.login-root/.login-card），
             登录成功后按 PC 口径进入 PC 端（/home/enterprise），不改当前端 URL。 -->
  <div class="login-root">
    <div class="login-card">
      <div class="logo"><span>数字化管理系统</span></div>
      <p class="cl-greeting-m">{{ subtitle }}</p>

      <div class="form-item">
        <label>手机号</label>
        <div class="input-wrap">
          <input v-model="phone" type="tel" maxlength="11" placeholder="请填写手机号" autocomplete="username" />
        </div>
      </div>

      <div class="form-item">
        <label>密码</label>
        <div class="input-wrap">
          <input
            v-model="password"
            :type="pwdVisible ? 'text' : 'password'"
            placeholder="请输入密码"
            autocomplete="current-password"
            @keyup.enter="doLogin"
          />
          <span class="eye-icon" @click="pwdVisible = !pwdVisible">{{ pwdVisible ? '🙈' : '👁' }}</span>
        </div>
      </div>

      <button class="login-btn" :disabled="loading" @click="doLogin">
        {{ loading ? '登录中…' : '登 录' }}
      </button>

      <div class="link-row">
        <a>忘记密码</a>
        <a>联系管理员开通账号</a>
      </div>
      <div class="err-tip" v-if="errMsg">{{ errMsg }}</div>
    </div>
  </div>
</template>

<script>
import { clientPasswordLogin, fetchProfile } from '@/util/clientAuth.js'

export default {
  name: 'PcLogin',
  props: {
    subtitle: { type: String, default: '使用员工账号登录以继续使用' }
  },
  data() {
    return { phone: '', password: '', pwdVisible: false, loading: false, errMsg: '' }
  },
  methods: {
    doLogin() {
      if (this.loading) { return }
      if (!this.phone || !this.password) {
        this.errMsg = '请填写手机号与密码'
        return
      }
      this.errMsg = ''
      this.loading = true
      clientPasswordLogin({ phone: this.phone, password: this.password, remember: true })
        .then(res => {
          if (!res || res.code != 200) {
            this.loading = false
            this.errMsg = (res && res.msg) || '登录失败，请检查手机号与密码'
            return
          }
          /* 探明角色端（失败不影响登录），随后**按 PC 口径**进入 PC 端。
             口径与 login.vue 桌面分支保持一致：>=800 → /home/enterprise。
             这里用整页加载（时间戳放在 hash 之前），避免残留上一会话的内存态。 */
          return fetchProfile(true).catch(() => null).then(() => {
            this.$emit('success', true)
            window.location.href = './?_pc=' + Date.now() + '#/home/enterprise'
          })
        })
        .catch(() => {
          this.loading = false
          this.errMsg = '登录失败，请检查网络后重试'
        })
    }
  }
}
</script>

<style scoped>
.login-root {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #1e3a8a 0%, #2f6bd8 55%, #4a90e2 100%);
  padding: 24px;
  box-sizing: border-box;
}
.login-card {
  width: 100%;
  max-width: 380px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 24px 70px rgba(15, 30, 70, .30);
  padding: 34px 26px 26px;
  box-sizing: border-box;
}
.logo { text-align: center; margin-bottom: 6px; }
.logo span {
  font-size: 22px; font-weight: 700;
  background: linear-gradient(135deg, #2b4c9b 0%, #4a7fe0 100%);
  -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
  letter-spacing: 1px;
}
.cl-greeting-m { text-align: center; font-size: 15px; color: #5b6478; font-weight: 500; margin: 4px 0 20px; }
.form-item { margin-bottom: 16px; }
.form-item label { display: block; font-size: 13px; color: #5b6478; margin-bottom: 8px; }
.input-wrap { width: 100%; position: relative; }
.input-wrap input {
  width: 100%; height: 50px; padding: 0 14px;
  border: 1px solid #e6e9f0; background: #f5f7fb; border-radius: 12px;
  font-size: 15px; color: #1d2129; outline: none; box-sizing: border-box;
  transition: border-color .2s, box-shadow .2s, background .2s;
}
.input-wrap input::placeholder { color: #aab1c2; }
.input-wrap input:focus { border-color: #4a7fe0; background: #eef3ff; box-shadow: 0 0 0 3px rgba(74, 127, 224, .18); }
.eye-icon {
  position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
  font-size: 18px; color: #909399; cursor: pointer; user-select: none;
}
.login-btn {
  display: block; width: 100%; height: 50px;
  background: linear-gradient(135deg, #2b4c9b 0%, #4a7fe0 100%);
  color: #fff; border: none; border-radius: 12px;
  font-size: 16px; font-weight: 600; letter-spacing: 2px;
  cursor: pointer; margin-top: 8px;
  box-shadow: 0 10px 24px rgba(43, 76, 155, .32);
  transition: opacity .2s;
}
.login-btn:active { opacity: .9; }
.login-btn:disabled { background: #a9c0f0; cursor: not-allowed; box-shadow: none; }
.link-row { display: flex; justify-content: space-between; margin-top: 14px; font-size: 13px; }
.link-row a { color: #4a7fe0; text-decoration: none; }
.err-tip { font-size: 12.5px; color: #f53f3f; margin-top: 10px; text-align: center; }
</style>



// WEBPACK FOOTER //
// src/components/PcLogin.vue